import { styled } from '@linaria/react';
import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { skyDark } from '../../styles/design-tokens';
import { Icon } from '../../ui-library/icon/icon';
import { Text } from '../../ui-library/typography/typography';

type Props = {
  icon?: string;
  text?: string;
  noFiltersApplied?: boolean;
};

export const ContentPlaceholder = ({ icon = 'mobiledata_off', text, noFiltersApplied = false }: Props) => {
  const i18n = useTranslation();
  // Resolve the default for `text` inside the body (not in the param default)
  // so the lookup runs through the language-subscribed t() — not the singleton
  // that would otherwise be needed at parameter-evaluation time.
  const resolvedText = text ?? i18n.t('common.labels.no_data');
  return (
    <Stack h="100%" justify="center" align="center" gap={24}>
      <Icon name={noFiltersApplied ? 'filter_list' : icon} size={40} color={skyDark} />
      <CenteredText size="regular" color={skyDark}>
        {noFiltersApplied ? i18n.t('common.labels.no_filters_applied') : resolvedText}
      </CenteredText>
    </Stack>
  );
};

const CenteredText = styled(Text)`
  max-width: 300px;
  text-align: center;
`;
